
// Custom hook to get proper redirect URLs for authentication
import { useState, useEffect } from "react";

export const useAuthRedirectUrl = () => {
  const [redirectUrls, setRedirectUrls] = useState<{
    baseUrl: string;
    successUrl: string;
    failureUrl: string;
    recoveryUrl: string;
  } | null>(null);

  useEffect(() => {
    // Get the full current URL
    const currentUrl = window.location.href;

    // Parse the URL to extract components
    const url = new URL(currentUrl);

    // For preview environments, we need to preserve the full path
    // The preview URL format is like: https://548c5075-33d0-466c-8111-0f1fd9b820c1.lovableproject.com/auth
    // or https://preview.lovable.dev/548c5075-33d0-466c-8111-0f1fd9b820c1/auth

    // Check if we're in a preview environment by looking at the hostname
    const isPreview = url.hostname.includes('lovableproject.com') || 
                     (url.hostname === 'preview.lovable.dev' && url.pathname.split('/').length > 2);
    
    let baseUrl = '';
    if (isPreview) {
      // For preview.lovable.dev format with path: /projectId/auth
      if (url.hostname === 'preview.lovable.dev') {
        // Split path, remove 'auth' from the end if present
        const pathParts = url.pathname.split('/').filter(Boolean);
        if (pathParts.length > 0) {
          // Keep the project ID part
          baseUrl = `${url.origin}/${pathParts[0]}`;
        }
      } else {
        // For projectId.lovableproject.com format
        baseUrl = url.origin;
      }
    } else {
      // For production or local environment
      baseUrl = url.origin;
    }
    
    // Always ensure auth path is correctly added to the redirects
    const authPath = '/auth';
    console.log('Auth base URL set to:', baseUrl);
    
    // Create recovery URL with proper query parameters
    // Ensure the type=recovery parameter is preserved for the password reset flow
    const recoveryUrl = `${baseUrl}${authPath}?type=recovery`;
    
    console.log('Recovery URL set to:', recoveryUrl);
    
    setRedirectUrls({
      baseUrl,
      successUrl: `${baseUrl}/settings`, // Redirect to settings on success
      failureUrl: `${baseUrl}${authPath}`, // Keep on auth page on failure
      recoveryUrl: recoveryUrl // Specific URL for password recovery with query param
    });
  }, []);

  return redirectUrls;
};
